export * from './nav-bar.component';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/components/navbar/index.ts